<template>
  <div v-if="loading">
    <div class="spinner text-xs-center" style="margin-top: 80px;">
      <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
    </div>
  </div>
  <div v-else>
    <v-layout wrap>
      <v-flex xs9>
        <h2>{{ $t('line_messages_after_order') }}</h2>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <template>
          <v-btn
            fab
            outline
            small
            color="primary"
            v-if="!isEditLineShoppingMessage"
            @click="isEditLineShoppingMessage = true"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <div>
      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1">
          <v-card class="line_card">
            <v-card-title>
              <v-container>
                <v-layout>
                  <v-flex xs12 class="my-4 text-xs-center">
                    <v-icon class="green--text">article</v-icon>
                    <v-icon class="lighten-5">more_horiz</v-icon>
                    <v-icon class="lighten-5">paid</v-icon>
                    <v-icon class="lighten-5">more_horiz</v-icon>
                    <v-icon class="lighten-5">payment</v-icon>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12>
                    <h2 style="color: black">
                      {{ $t('thankyou_purchase') }}
                    </h2>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12>
                    <p style="color: #000000b0">{{ $t('wait_for_confirm_purchase') }}</p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-title>
            <v-card-text>
              <v-container>
                <p style="color: #000000b0">{{ $t('line_order_number') }}</p>
                <h3 style="color: black">#{{ line_order_number }}</h3>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-layout>
                <v-flex class="text-xs-center">
                  <a class="green--text" ref="#">{{ $t('Details') }}</a>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-divider />
        <v-flex xs12 sm6 class="pa-1">
          <v-container>
            <template v-if="isEditLineShoppingMessage">
              <div>
                <IntentGroup
                  :isLineShopping="true"
                  :isEditLineShoppingMessage="isEditLineShoppingMessage"
                  v-model="messages"
                ></IntentGroup>
              </div>
            </template>
            <template v-else>
              <template v-if="messages && messages[0].length > 0">
                <message-viewer v-model="messages"></message-viewer>
              </template>
              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
            </template>
          </v-container>
        </v-flex>
      </v-layout>
    </div>

    <div class="text-xs-center mt-3" v-if="isEditLineShoppingMessage">
      <v-btn outline color="grey" @click="cancelEditAfterOrderLineShopping">{{
        $t('cancel')
      }}</v-btn>
      <v-btn depressed color="primary" @click="saveEditAfterOrderLineShopping">{{
        $t('Save')
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
//component
import IntentGroupItem from '../view/intent/IntentGroupItem.js'
import IntentGroup from '../view/intent/IntentGroup.vue'
export default {
  props: {
    isLineShopping: {
      dafault: false,
      type: Boolean
    }
  },
  data: function() {
    return {
      isEditLineShoppingMessage: false,
      line_order_number: 20000000123,
      messages: [],
      defaultMessage: '',
      loading: false
    }
  },
  components: {
    IntentGroup
  },
  mixins: [IntentGroupItem],
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    const vm = this
    vm.get_line_order_messages()
  },
  methods: {
    async get_line_order_messages() {
      const vm = this
      if (!vm.selectedBot) {
        return false
      }
      const data = {
        pageid: vm.selectedBot.pageid,
        type: 'json'
      }
      try {
        const res = await api.get_line_order_messages(data)
        vm.defaultMessage = res.result.messages
        const message = JSON.parse(res.result.messages)
        const newMessages = []

        if (message != 'null') {
          if (message.length > 1) {
            message.forEach((m, index) => {
              newMessages.push({
                type: 'text',
                text: m.text
              })
            })
          } else {
            newMessages.push({
              type: 'text',
              text: message[0].text
            })
          }
          vm.messages = [newMessages]
        } else {
          vm.messages = [[]]
        }
      } catch (error) {
        vm.messages = [[]]
      }
    },
    cancelEditAfterOrderLineShopping: function() {
      const vm = this
      try {
        vm.get_line_order_messages()
        const defaultMessages = JSON.parse(vm.defaultMessage)
        vm.messages = defaultMessages.length > 0 ? [defaultMessages] : [[]]
      } catch (error) {
        console.log(error)
      }

      vm.isEditLineShoppingMessage = false
    },
    async saveEditAfterOrderLineShopping() {
      const vm = this
      vm.loading = true
      const messages = vm.messages
      if (!vm.selectedBot) {
        return false
      }
      const data = {
        params: {
          pageid: vm.selectedBot.pageid
        },
        body: {
          messages: JSON.stringify(messages[0])
        }
      }

      const response = await api.put_line_order_messages(data)
      if (response.success) {
        vm.loading = false
        vm.isEditLineShoppingMessage = false
      } else {
        vm.$swal({
          title: 'Error',
          text: 'An error occurred!',
          icon: 'error'
        })
      }
    }
  }
}
</script>

<style scoped>
.line_card {
  -webkit-box-shadow: none;
  box-shadow: none;
  text-decoration: none;
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/lineShoppingOrder.vue